module.exports = __webpack_public_path__ + "static/media/full-cover-background.2932a7cc.png";